import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialNotificationBannerState, NotificationBannerState } from './notificationBannerState';
import { NotificationBannerConfig, NotificationBannerFeature } from '../../../domain/chat/models/NotificationBanner';

export const notificationBannerSlice = createSlice({
	name: 'notificationBanner',
	initialState: initialNotificationBannerState,
	reducers: {
		setShowNotificationBannerDialog: (state: NotificationBannerState, action: PayloadAction<boolean>) => {
			state.showNotificationDialog = action.payload;
		},
		setCarouselIndex: (state: NotificationBannerState, action: PayloadAction<number>) => {
			state.carouselIndex = action.payload;
		},
		setShowFeatureHighlight: (state: NotificationBannerState, action: PayloadAction<boolean>) => {
			state.showFeatureHighlight = action.payload;
		},
		setFeatureHighlightData: (state: NotificationBannerState, action: PayloadAction<NotificationBannerFeature | null>) => {
			state.featureHighlightData = action.payload;
		},
		setShouldScrollToFeature: (state: NotificationBannerState, action: PayloadAction<boolean>) => {
			state.shouldScrollToFeature = action.payload;
		},
		setBannerConfig: (state: NotificationBannerState, action: PayloadAction<Partial<NotificationBannerConfig>>) => {
			state.bannerConfig = action.payload ?? {};
		},
	},
});

export const {
	setShowNotificationBannerDialog,
	setCarouselIndex,
	setShowFeatureHighlight,
	setFeatureHighlightData,
	setShouldScrollToFeature,
	setBannerConfig,
} = notificationBannerSlice.actions;

export default notificationBannerSlice.reducer;
